export const milestone = {
    region: '',
    language: '',
    milestones: [],
    articles: [],
    get schema() {
        return {
            title: 'Milestone',
            type: 'object',
            properties: {
                type: {
                    title: 'Type',
                    type: 'string',
                    enum: ['Non-Scoring', 'Scoring', 'Contingent Scoring'],
                },
                content: {
                    title: 'Content',
                    type: 'string',
                    format: 'textarea',
                },
                scoringLevel: {
                    title: 'Scoring Level',
                    type: 'integer',
                    minimum: 1,
                    maximum: 10,
                },
                scoringMilestone: {
                    title: 'Scoring Milestone',
                    type: 'string',
                    enum: [''].concat(this.milestones
                        .filter((a) => a.region === this.region && a.language === this.language)
                        .sort((a, b) => a.title.localeCompare(b.title))
                        .map((a) => a.id)),
                    options: {
                        enum_titles: [''].concat(this.milestones
                            .filter((a) => a.region === this.region && a.language === this.language)
                            .sort((a, b) => a.title.localeCompare(b.title))
                            .map((a) => a.title)),
                    },
                },
                rank: {
                    title: 'Rank',
                    type: 'integer',
                    minimum: 1,
                    maximum: 99999,
                },
            },
        };
    },
};
//# sourceMappingURL=milestoneJsonEditorConfig.js.map